import { render, staticRenderFns } from "./hospital_out.vue?vue&type=template&id=96e150ec&scoped=true"
import script from "./hospital_out.vue?vue&type=script&lang=js"
export * from "./hospital_out.vue?vue&type=script&lang=js"
import style0 from "./hospital_out.vue?vue&type=style&index=0&id=96e150ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e150ec",
  null
  
)

export default component.exports